<div class="header">
  <div class="header-cont modals">
    <h2 mat-dialog-title>{{ 'admin_single_itin.dialog.title_att' | translate }}</h2>
    <mat-icon>attach_file</mat-icon>
  </div>
</div>

<input #attInput multiple type="file" hidden="true" onclick="this.value=null" (change)="inputChange($event)" accept="audio/*|image/*|video/*|.doc|.txt|.pdf"/>
<div class="att-name">

  <ng-container *ngIf="noNewAttach(); else noNew">
    <p class="no-attach">{{ att_name }}</p>
  </ng-container>
  <ng-template #noNew>
    <p>{{ att_name }}</p>
  </ng-template>

    <!-- Aggiungere classe con ngif -->
  <button mat-raised-button class="add-att" (click)="attInput.click()">
    <mat-icon class="footer-icon">attach_file</mat-icon>
    <span>{{ 'admin_single_itin.buttons.add_att' | translate }}</span>
  </button>
</div>

<div *ngIf="wrong_type && !noNewAttach()" class="wrong-att">
  <p>{{ 'attachment.wrong' | translate }}</p>
</div>
<div *ngIf="wrong_size && !noNewAttach()" class="wrong-att">
  <p>{{ 'attachment.size' | translate }} {{size[file_type] / 1000000}} MB</p>
</div>

<mat-form-field class="section-input">
  <mat-label>{{ 'admin_single_itin.dialog.src' | translate }}</mat-label>
  <input matInput type="text" required (keyup)="addSrc($event)">
</mat-form-field>

<mat-dialog-actions align="center" class="dialog-btns">
    <button mat-button [mat-dialog-close]="false" (click)="onNoClick()">{{ 'admin_single_itin.dialog.cancel' | translate }}</button>
    <button mat-button [mat-dialog-close]="newFile()" [disabled]="wrong_type || !not_empty_src" cdkFocusInitial class="dialog-confirm">{{ 'admin_single_itin.dialog.ok' | translate }}</button>
</mat-dialog-actions>

<app-loading-overlay [loading]="loading"></app-loading-overlay>
